import { Component, Element, h, Host } from "@stencil/core";

/**
 * @slot text - Slot for the footer text.
 * @slot cta - Slot for the call-to-action buttons.
 */
@Component({
    tag: "ux-iws-sf-cta-footer",
    styleUrl: "sf-cta-footer.scss",
    shadow: false,
})
export class SfCtaFooter {
    private baseClass: string = "ux-iws-sf-cta-footer";
    private hasTextSlot: boolean = false;

    @Element() element: HTMLUxIwsSfCtaFooterElement;

    componentWillLoad() {
        this.hasTextSlot =
            this.element.querySelector(`[slot="text"]`) instanceof HTMLElement;
    }

    render() {
        return (
            <Host class={`${this.baseClass}`}>
                <div
                    class={
                        this.hasTextSlot
                            ? `${this.baseClass}__text`
                            : `${this.baseClass}__hidden`
                    }
                >
                    <slot name="text" />
                </div>
                <div class={`${this.baseClass}__cta`}>
                    <slot name="cta" />
                </div>
            </Host>
        );
    }
}
